<template>
    <div class="main">
        <title-component :title="title"></title-component>
        <key-indicators-component :resultData="resultData" :bizCode="bizCode"></key-indicators-component>
        <business-trends-component :bizCode="bizCode"></business-trends-component>
    </div>
</template>

<style lang="scss" scoped="scoped">
    * {
        margin: 0;
        padding: 0;
    }
    .main {
        min-height: 100%;
        background-color: #F7F9FA;
        padding: 20px 15px;
    }
</style>

<script>
    import TitleComponent from '../components/title/Title.vue'
    import KeyIndicatorsComponent from './components/key-indicators/KeyIndicators.vue'
    import BusinessTrendsComponent from './components/business-trends/BusinessTrends.vue'
    import DataPlatform from 'api/dataPlatform'
    import MomentFormat from '../filters/moment-format'

    export default {
        components: {
            TitleComponent,
            KeyIndicatorsComponent,
            BusinessTrendsComponent
        },
        data () {
            const data = {
                title: '服务数据',
	            bizCode: null, // 业务线
	            startDate: MomentFormat.getYestoday(),  // 开始日期，默认昨天
	            endDate: MomentFormat.getYestoday(), // 结束日期，默认昨天
	            resultData: {}
            }
	        switch (this.$route.params.type||this.$route.meta.type) {
		        case 'gty': data.bizCode = 11021;
			        break;
		        case 'jiujing': data.bizCode = 11022;
			        break;
		        default: window.location.href = '/'
	        }
	        // 获取初始数据
	        DataPlatform.getOperationData(data.bizCode, data.startDate, data.endDate)
                .then((res) => {
                    console.log(res);
                    if (res.status === 0) {
                        data.resultData = res.data;
                    } else {
                        this.$notify.error({
                            title: '错误',
                            message: res.message || '请求失败'
                        })
                    }
                })
                .catch((err) => {
                    console.log(err);
                })
	        return data;
        },
        methods: {

        }
    }
</script>




// WEBPACK FOOTER //
// Main.vue?7eee841c